import { Button } from "react-bootstrap";
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ListPaginationApplication from "../components/misc/ListPaginationApplicatiion";
import ListPaginationLoanProcessing from "../components/misc/ListPaginationLoanProcessing";
import UpcomingDueDates from "../components/misc/UpcomingDueDates";

function Dashboard() {
    return (
        <>
            <NavMain slug="dashboard" parent="0" />
            <HeaderMain slug="dashboard" />
            <div className="main-content">
                <div className="quick-links">
                    <Button variant="primary" href="/application-form"><i className="fa-solid fa-folder-plus"></i> New Application</Button>
                    <Button variant="primary" href="/loan-processing"><i className="fa-solid fa-spinner"></i> Loan Processing</Button>
                    <Button variant="primary" href="/add-repayment"><i className="fa-solid fa-credit-card"></i> Add Payment</Button>
                    <Button variant="primary" href="/loan-application-page" target="_blank"><i className="fa-solid fa-align-justify"></i> Pre Application Page</Button>
                </div>
                <ListPaginationApplication />
                <ListPaginationLoanProcessing />
                <UpcomingDueDates />
            </div>
        </>
    );
}

export default Dashboard;